import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Sidebar from '../components/Sidebar';
import songicon from '../assets/sound.png'
import Reflect from '../assets/Reflect.png'
import IntroVideo from '../assets/4K.mp4'
import Discover from '../assets/Discover.png'
import Revisit from '../assets/Revisit.png'

const EssenceEcho = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const { user } = useAuth();
    const navigate = useNavigate();

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const closeSidebar = () => {
        setSidebarOpen(false);
    };

    const handleBeginReflection = () => {
        if (user) {
            // User is logged in, go directly to SevenQuestion
            navigate('/sevenquestion');
        } else {
            // User is not logged in, redirect to login with return URL
            navigate('/login', { state: { from: '/sevenquestion' } });
        }
    };

    // Redirect logged-in users directly to SevenQuestion
    useEffect(() => {
        if (user) {
            navigate('/sevenquestion', { replace: true });
        }
    }, [user, navigate]);

    const displayName = (() => {
        try {
            if (user?.firstName) return String(user.firstName).trim();
            if (user?.name && typeof user.name === 'string') {
                const firstWord = user.name.trim().split(/\s+/)[0];
                return firstWord || 'User';
            }
            return 'User';
        } catch (_) {
            return 'User';
        }
    })();

    const [showIntroVideo, setShowIntroVideo] = useState(true);
    const videoRef = useRef(null)

    useEffect(() => {
        // lock scroll while the overlay is visible
        if (showIntroVideo) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = ''
        }
        return () => { document.body.style.overflow = '' }
    }, [showIntroVideo])

    return (
        <div className='flex min-h-screen w-full overflow-x-hidden bg-gray-800'>

            <div className='flex-1 relative'>

                {/* Hear yourself clearly again Main Content Area */}
                <div className="bg-gray-800 min-h-screen px-8 py-8">
                    <div className="bg-white rounded-2xl shadow-xl max-w-4xl mx-auto p-8">
                        <div className="text-center mb-8">
                            <div className="flex items-center justify-center gap-3 mb-4">
                                <img
                                    src={songicon}
                                    style={{
                                        width: '40px',
                                        height: '40px',}}
                                />
                                <h1 className="text-3xl font-bold text-gray-800" style={{fontFamily: 'Playfair Display, serif', fontSize:32}}>
                                    Hear yourself clearly again
                                </h1>
                            </div>
                            <p className="  font-normal text-[16px] leading-[19px] text-center text-[#9E9FA0] " style={{width:'60%', margin:'0 auto'}}>
                                {user ? (
                                    <>Welcome back, {displayName}! Essence Echo is a self-reflective experience that helps you uncover the values, passions, and patterns that make you who you are — beyond labels or categories.</>
                                ) : (
                                    <>Essence Echo is a self-reflective experience that helps you uncover the values, passions, and patterns that make you who you are — beyond labels or categories.</>
                                )}
                            </p>
                        </div>

                        <div className="space-y-4 mb-8 bg-[linear-gradient(93.27deg,_#F3F3FE_4.94%,_#F9F3FF_95.06%)] rounded-lg p-4">
                            <div className="bg-[#fff] rounded-lg p-4">
                                <p className="text-black-700">
                                    In a world full of noise <span className="text-[#7279EE] font-medium">Essence Echo gives you space to listen</span>, not to others but to yourself.
                                </p>
                            </div>
                            <div className="bg-[#fff] rounded-lg p-4">
                                <p className="text-black-700">
                                    These answers will change as you do, and that is the point. Each response captures a snapshot of <span className="text-[#7279EE] font-medium">your essence in this moment</span>, a starting reflection you can revisit later in your journey.
                                </p>
                            </div>
                            <div className="bg-[#fff] rounded-lg p-4">
                                <p className="text-black-700">
                                    Through seven open-ended reflections, you'll uncover what truly drives you: the <span className="text-[#7279EE] font-medium">values</span> that guide you, the <span className="text-[#7279EE] font-medium">passions</span> that move you, the <span className="text-[#7279EE] font-medium">goals</span> that call you forward, and the <span className="text-[#7279EE]font-medium">patterns</span> that shape your path.
                                </p>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                            <div className="bg-[linear-gradient(90deg,_#F6FCFF_0%,_#F2FAFE_100%)] shadow-[0_2px_7px_rgba(0,0,0,0.07)] rounded-lg p-4 " style={{display:'flex', flexDirection:'column', justifyContent:"start", alignItems:'center',  textAlign:"center", padding:'10px'}}>
                                <img
                                    src={Reflect}
                                    style={{
                                        width: '50px',
                                        height: '50px',}}
                                />
                                <h3 className=" font-bold text-[20px] leading-[24px] text-center text-[#489CDF] mb-2 mt-2" style={{fontFamily: 'Lato, sans-serif'}}>Reflect</h3>
                                <p className="text-[#9E9FA0] text-sm" style={{fontFamily: 'Lato, sans-serif'}}>
                                    Answer seven short, meaningful prompts that explore your inner landscape.
                                </p>
                            </div>

                            {/* Discover Card */}
                            <div className="bg-[linear-gradient(93.82deg,_#FFFAFF_0.85%,_#FEF5FF_100%)] shadow-[0_2px_7px_rgba(0,0,0,0.07)] rounded-lg p-4" style={{display:'flex', flexDirection:'column', justifyContent:"start", alignItems:'center', textAlign:'center', padding:'10px'}}>
                                <img
                                    src={Discover}
                                    style={{
                                        width: '50px',
                                        height: '50px',}}
                                />
                                <h3 className="font-bold text-[20px] leading-[24px] text-center text-[#C136DB] text-lg mb-2 mt-2" style={{fontFamily: 'Lato, sans-serif'}}>Discover</h3>
                                <p className="text-[#9E9FA0] text-sm" style={{fontFamily: 'Lato, sans-serif'}}>
                                    See themes, patterns, and insights surface from your own words.
                                </p>
                            </div>

                            {/* Revisit Card */}
                            <div className="bg-[linear-gradient(90deg,_#FCFFFC_0%,_#F9FFF9_100%)] shadow-[0_2px_7px_rgba(0,0,0,0.07)] rounded-lg p-4" style={{display:'flex', flexDirection:'column', justifyContent:"start", alignItems:'center', textAlign:'center', padding:'10px'}}>
                                <img
                                    src={Revisit}
                                    style={{
                                        width: '50px',
                                        height: '50px',}}
                                />
                                <h3 className="font-bold text-[20px] leading-[24px] text-center text-[#37C23C] mb-2 mt-2" style={{fontFamily: 'Lato, sans-serif'}}>Revisit</h3>
                                <p className="text-[#9E9FA0] text-sm">
                                    Return later to see how your essence evolves as you grow.
                                </p>    
                            </div>
                        </div>

                        {/* Disclaimer */}
                        <div className="text-center mb-8">
                            <p className="text-[#7A81FF] font-medium">
                                There are no scores here. No right answers. Only clarity for where you are right now.
                            </p>
                        </div>

                        {/* Call to Action Button */}
                        <div className="text-center">
                            <button
                                onClick={handleBeginReflection}
                                className="bg-[#7A81FF] text-white px-8 py-3 rounded-lg text-lg font-semibold hover:from-purple-600 hover:to-blue-600 transition-all duration-300 shadow-lg" style={{width:'40%'}}
                            >
                                Begin My Reflection
                            </button>
                        </div>

                        {/* Time Estimate */}
                        <div className="text-center mt-4">
                            <p className="text-gray-500 text-sm">
                                Takes about <span className="text-[#7279EE] font-medium">10 minutes.</span>  No right or wrong answers.
                            </p>
                        </div>
                    </div>
                </div>

                {showIntroVideo && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center">
                        <div className="absolute inset-0 bg-black"></div>
                        <div className="relative z-10 w-11/12 md:w-3/4 lg:w-2/3 rounded-2xl overflow-hidden shadow-2xl" style={{boxShadow:'0 10px 30px rgba(0,0,0,0.4)'}}>
                            <button onClick={() => { try { if (videoRef.current) { videoRef.current.pause(); videoRef.current.src = ''; } } catch(_){}; setShowIntroVideo(false); }} className="absolute top-3 right-3 bg-white/80 hover:bg-white text-gray-800 text-xs px-3 py-1 rounded z-20">
                                Skip video ✕
                            </button>
                            <video ref={videoRef} src={IntroVideo} controls autoPlay muted playsInline className="w-full h-full block" />
                            <div className="bg-black/60 py-3 font-normal text-[24px] leading-[32px] text-white text-center" style={{fontFamily: 'Lato, sans-serif'}}>Welcome to Essence Echo</div>
                        </div>
                    </div>
                )}
            </div>


        </div>
    );
};

export default EssenceEcho;
